import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import Icon from 'components/Icon'
import { Box } from 'components/Layout'
import { COLOR } from 'Theme'

const Circle = styled.circle`
  fill: transparent;
  cx: ${(props) => props.radius};
  cy: ${(props) => props.radius};
`

const CircleBackground = styled(Circle)`
  transition: stroke-dashoffset 0.8s;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
`

const StyledSvg = styled.svg`
  transform: rotate(-90deg);
`

const ProgressIndicator = ({
  percentage,
  ringColor,
  ringBackground,
  checkmarkColor,
  size,
  stroke,
  ...props
}) => {
  const normalizedRadius = size - 2 * 2
  const circumference = normalizedRadius * 2 * Math.PI
  const strokeDashoffset = circumference - (percentage / 100) * circumference
  const iconCheckmarkSize = size * 2
  return (
    <Box {...props}>
      {percentage === 100 ? (
        <Icon.CircleCheckmark size={iconCheckmarkSize} color={checkmarkColor} />
      ) : (
        <StyledSvg height={size * 2} width={size * 2}>
          <CircleBackground
            strokeWidth={stroke}
            style={{ strokeDashoffset }}
            r={normalizedRadius}
            radius={size}
            stroke={ringBackground}
          />
          <Circle
            strokeWidth={stroke}
            strokeDasharray={`${circumference} ${circumference}`}
            style={{ strokeDashoffset }}
            r={normalizedRadius}
            radius={size}
            ProgressIndicator
            stroke={ringColor}
          />
        </StyledSvg>
      )}
    </Box>
  )
}

ProgressIndicator.defaultProps = {
  ringColor: COLOR.SECONDARY_1,
  ringBackground: COLOR.GRAYSCALE_4,
  checkmarkColor: COLOR.PRIMARY_1,
  size: 12,
  stroke: 2,
}

ProgressIndicator.propTypes = {
  percentage: PropTypes.number.isRequired,
  ringColor: PropTypes.string,
  ringBackground: PropTypes.string,
  checkmarkColor: PropTypes.string,
  size: PropTypes.number,
  stroke: PropTypes.number,
}

export default ProgressIndicator
